const SET_SELECTED_PRODUCT = 'publicador/step4Module2/SET_SELECTED_PRODUCT';
const SET_SELECTED_LOCATION = 'publicador/step4Module2/SET_SELECTED_LOCATION';
const GET_ECOMMERCE_USER = 'publicador/step4Module2/GET_ECOMMERCE_USER';
const GET_ECOMMERCE_USER_COMPLETED = 'publicador/step4Module2/GET_ECOMMERCE_USER_COMPLETED';
const GET_ECOMMERCE_USER_FAILED = 'publicador/step4Module2/GET_ECOMMERCE_USER_FAILED';
const GET_PRODUCT_TAXES = 'publicador/step4Module2/GET_PRODUCT_TAXES';
const GET_PRODUCT_TAXES_COMPLETED = 'publicador/step4Module2/GET_PRODUCT_TAXES_COMPLETED';
const GET_PRODUCT_TAXES_FAILED = 'publicador/step4Module2/GET_PRODUCT_TAXES_FAILED';
const UPDATE_PRODUCT_TAXES = 'publicador/step4Module2/UPDATE_PRODUCT_TAXES';
const UPDATE_PRODUCT_TAXES_COMPLETED = 'publicador/step4Module2/UPDATE_PRODUCT_TAXES_COMPLETED';
const UPDATE_PRODUCT_TAXES_FAILED = 'publicador/step4Module2/UPDATE_PRODUCT_TAXES_FAILED';
const GET_TAX_CONDITIONS = 'publicador/step4Module2/GET_TAX_CONDITIONS';
const GET_TAX_CONDITIONS_COMPLETED = 'publicador/step4Module2/GET_TAX_CONDITIONS_COMPLETED';
const GET_TAX_CONDITIONS_FAILED = 'publicador/step4Module2/GET_TAX_CONDITIONS_FAILED';
const GET_LOCATION_LEVEL = 'publicador/step4Module2/GET_LOCATION_LEVEL';
const GET_LOCATION_LEVEL_COMPLETED = 'publicador/step4Module2/GET_LOCATION_LEVEL_COMPLETED';
const GET_LOCATION_LEVEL_FAILED = 'publicador/step4Module2/GET_LOCATION_LEVEL_FAILED';
const SET_PAYMENT_LOADER = 'publicador/step4Module2/SET_PAYMENT_LOADER';
const CREATE_INACTIVE_ORDER = 'publicador/step4Module2/CREATE_INACTIVE_ORDER';
const SET_TAX_CONDITIONS = 'publicador/step4Module2/SET_TAX_CONDITIONS';

export {
  SET_SELECTED_PRODUCT,
  GET_ECOMMERCE_USER,
  GET_ECOMMERCE_USER_COMPLETED,
  GET_ECOMMERCE_USER_FAILED,
  GET_PRODUCT_TAXES,
  GET_PRODUCT_TAXES_COMPLETED,
  GET_PRODUCT_TAXES_FAILED,
  UPDATE_PRODUCT_TAXES,
  UPDATE_PRODUCT_TAXES_COMPLETED,
  UPDATE_PRODUCT_TAXES_FAILED,
  GET_TAX_CONDITIONS,
  GET_TAX_CONDITIONS_COMPLETED,
  GET_TAX_CONDITIONS_FAILED,
  GET_LOCATION_LEVEL,
  GET_LOCATION_LEVEL_COMPLETED,
  GET_LOCATION_LEVEL_FAILED,
  SET_SELECTED_LOCATION,
  SET_PAYMENT_LOADER,
  CREATE_INACTIVE_ORDER,
  SET_TAX_CONDITIONS
};
